import { fetchDefault, type RequestOptions } from './default'

export const fetchWithSession = async <T = any>(
  resource: string,
  token: string,
  options?: RequestOptions,
): Promise<T | null> => {
  const optionsWithSession = {
    ...options,
    headers: {
      ...options?.headers,
      'X-Bifrost-Authorization': token,
    },
  }
  return fetchDefault<T>(resource, optionsWithSession)
}
